import { doMutation } from "../../core-module/util/graphqlHelper";
import { apolloClient } from "@/plugins/vue-apollo";

const updateGetTrainingsCache = ({ trainingId, variables }) => {
  try {
    if (trainingId) {
      const cacheKey = {
        query: require("../api/query/getTrainings.gql"),
        variables: variables,
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (cachedData?.getTrainings) {
        const existingTrainingIndex =
          cachedData.getTrainings.trainings.findIndex(
            x => x._id === trainingId
          );

        if (existingTrainingIndex >= 0) {
          cachedData.getTrainings.trainings.splice(existingTrainingIndex, 1);
        }

        apolloClient.writeQuery({ ...cacheKey, data: cachedData });
      }
    }
  } catch (e) {
    console.log("deleteTraining.updateGetTrainingsCache:exception:", e.message);
  }
};

export const deleteTraining = id => {
  const mutation = require("../api/mutation/deleteTraining.gql");
  const variables = {
    id: id,
  };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetTrainingsCache({
        trainingId: data?.deleteTraining?._id,
        variables: {
          limit: 0,
          skip: 0,
        },
      });
      return { data: data.deleteTraining };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
